if (!customElements.get('sophia-shade-finder')) {
  customElements.define('sophia-shade-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-sf-open]');
      if (!this.dialog || !this.trigger) return;
      this.initialized = true;
      this.addEventListener('click', this.onClick.bind(this));
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      });
    }

    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    showStep(name, focus = true) {
      this.querySelectorAll('[data-sf-step]').forEach(step => {
        step.hidden = step.dataset.sfStep !== name;
      });
      this.dialog.scrollTop = 0;
      if (focus) this.querySelector('[data-sf-step="' + name + '"] [data-sf-focus]').focus({ preventScroll: true });
    }

    onClick(event) {
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        return;
      }
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-sf-open')) {
        this.tone = null;
        this.showStep('tone', false);
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.showStep('tone');
      } else if (button.hasAttribute('data-sf-close')) {
        this.dialog.close();
      } else if (button.hasAttribute('data-sf-back')) {
        this.tone = null;
        this.showStep('tone');
      } else if (button.dataset.sfTone) {
        this.tone = button.dataset.sfTone;
        this.showStep('concern');
      } else if (button.dataset.sfConcern && this.tone) {
        const concern = button.dataset.sfConcern;
        const toneShades = { fair: 'pink', lightmed: 'pink_peach', medium: 'coral_peach', deep: 'orange_brown' };
        let shade = toneShades[this.tone];
        if (concern === 'red') shade = 'soft_mint';
        else if (concern === 'tired' && this.tone === 'lightmed') shade = 'pink';
        const result = this.querySelector('[data-sf-shade="' + shade + '"]');
        if (!result) return;
        this.querySelector('[data-sf-result]').replaceChildren(result.content.cloneNode(true));
        this.showStep('result');
      }
    }
  });
}
